<script setup>
import { defineProps, defineEmits, } from 'vue';
import DesignButton from './design-system/design-button.vue';


defineProps({
    modelValue: Boolean,
    buttonText: String,
    disabled: Boolean,
    hideTitle: Boolean,
    title: String,
    noneOverflowAuto: { type: Boolean, default: false },
    maxHeight: { type: String, default: '70vh' },
    width: { type: String, default: '480px' },
    minWidth: { type: String, default: '' },
    height: { type: String, default: '' },
    viewCancel : { type : Boolean, default : true },
    titleCenter : { type : Boolean, default : true },
});

const emit = defineEmits(['update:modelValue', 'buttonEvent', 'afterClose']);

function hidePopup() {
    emit('update:modelValue', false);
    emit('afterClose');
}

function buttonEvent() {
    emit('buttonEvent');
}
</script>

<template>
    <div v-show="modelValue" class="fixed top-0 w-full h-full bg-transparent-basic-3 z-[80] flex justify-center items-center">
        <div class="rounded-4 shadow-card bg-white"
            :style="{ width, minWidth: minWidth || undefined, height: height || undefined }">
            <div class="w-full"
                :class="noneOverflowAuto ? '' : 'overflow-auto'"
                :style="{ maxHeight }">
                <template v-if="hideTitle">
                    <slot />
                </template>
                <template v-else>
                    <div class="h-[4.125rem] px-7 py-4 flex "
                        :class="titleCenter ? 'justify-center items-center text-center' : 'justify-left items-left text-left' ">
                        <h2 class="font-heading-sm-bold">{{ title }}</h2>
                    </div>
                    <div class="w-full h-px bg-border-basic-2"></div>
                    <div class="min-h-[6rem] flex flex-col justify-center items-center px-2 py-4">
                        <div class="text-center text-content-basic-2 font-body-sm-regular">
                            <slot />
                        </div>
                    </div>
                    <div class="w-full h-px bg-border-basic-2"></div>
                    <div class="h-auto flex justify-center items-center gap-4 py-4">
                        <DesignButton
                            v-if="viewCancel"
                            btnText="Cancel"
                            btnSize="MD"
                            btnType="SECONDARY"
                            btnVariant="BORDER"
                            class="w-[6rem]"
                            @click-event="hidePopup" />
                        <DesignButton
                            :btnText="buttonText || 'Confirm'"
                            btnSize="MD"
                            btnType="PRIMARY"
                            btnVariant="FILL"
                            class="w-[6rem]"
                            @click-event="buttonEvent" />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
